export enum StockSignalsEnum {
    SIGNALS_4H              = 'signals4h', // ['signals4h', 'Signal 4h'],
    SIGNALS_2H              = 'signals2h', // ['signals2h', 'Signal 2h'],
    SIGNALS_LAST_3PRED      = 'signalsLast3pred', // ['signalsLast3pred', 'Signal Last3PredAvg'],
    SIGNALS_LAST_15MIN      = 'signalsLast15m', //    ['signalsLast15m', 'Signal Last15mAvg'],
    SIGNALS_MACD_CROSS      = 'signalsMacdCross', //    ['signalsMacdCross', 'Signals Macd Cross'],
    SIGNALS_EMA6_PRICE      = 'signalsEma6Price',
    SIGNALS_EMA12_PRICE     = 'signalsEma12Price',
    SIGNALS_EMA26_PRICE     = 'signalsEma26Price',
    SIGNALS_EMA120_PRICE     = 'signalsEma120Price',
    SIGNALS_VWAP_PRICE      = 'signalsVwapPrice',
    SIGNALS_CONSENSUS_3PRED_10M = 'signalsConsensus3Pred10m',
    SIGNALS_CONSENSUS_4PRED_10M = 'signalsConsensus4Pred10m',
    SIGNALS_CONSENSUS_5PRED_10M = 'signalsConsensus5Pred10m',
    SIGNALS_2H_MIN_MAX_220PCT_PRED    = 'signals2hMinMax220pctPred',
    SIGNALS_2H_MIN_MAX_160PCT_STOCK   = 'signals2hMinMax160pctStock',
    SIGNALS_2H_MIN_MAX_220PCT_STOCK   = 'signals2hMinMax220pctStock',
    SIGNALS_2H_MIN_MAX_160PCT_STOCK_INSIDE   = 'signals2hMinMax160pctStockInside',
    SIGNALS_2H_MIN_MAX_220PCT_STOCK_INSIDE   = 'signals2hMinMax220pctStockInside',
    SIGNALS_2H_MIN_MAX_220PCT_STOCK_3PRED = 'signals2hMinMax220pctStock3Pred',
    SIGNALS_SUP_RES_1H_STOCK                = 'signalsSupRes1HStock',

    // SIGNALS_TREND_LINES_STOCK_OUTSIDE                = 'signalsTrendLinesOutside',
    SIGNALS_OPEN_LINE_STOCK                          = 'signalsOpenLine',
    SIGNALS_PREV_ClOSE_LINE_STOCK                    = 'signalsCloseLine',

    SIGNALS_LAST_2H_AVG_STOCK                       = 'signalsLast2hAvgStock',
}

export const SignalsMap: ReadonlyMap<StockSignalsEnum, string> = new Map<StockSignalsEnum, string>([
    // ['', 'None'],
    [StockSignalsEnum.SIGNALS_4H, 'Signals 4hMinMax160pctStock3Pred'],
    [StockSignalsEnum.SIGNALS_2H, 'Signals 2hMinMax160pctStock3Pred'],
    [StockSignalsEnum.SIGNALS_LAST_3PRED, 'Signals Last3PredAvg'],
    [StockSignalsEnum.SIGNALS_LAST_15MIN, 'Signals Last15mAvg'],
    [StockSignalsEnum.SIGNALS_MACD_CROSS, 'Signals Macd Cross'],
    [StockSignalsEnum.SIGNALS_EMA6_PRICE, 'Signals Ema6 Price'],
    [StockSignalsEnum.SIGNALS_EMA12_PRICE, 'Signals Ema12 Price'],
    [StockSignalsEnum.SIGNALS_EMA26_PRICE, 'Signals Ema26 Price'],
    [StockSignalsEnum.SIGNALS_EMA120_PRICE, 'Signals Ema120 Price'],
    [StockSignalsEnum.SIGNALS_VWAP_PRICE, 'Signals VWAP Price'],
    [StockSignalsEnum.SIGNALS_CONSENSUS_3PRED_10M, 'Signals Cons. 3Pred10Min'],
    [StockSignalsEnum.SIGNALS_CONSENSUS_4PRED_10M, 'Signals Cons. 4Pred10Min'],
    [StockSignalsEnum.SIGNALS_CONSENSUS_5PRED_10M, 'Signals Cons. 5Pred10Min'],
    [StockSignalsEnum.SIGNALS_2H_MIN_MAX_220PCT_PRED, 'Signals 2hMinMax220pctPred'],
    [StockSignalsEnum.SIGNALS_2H_MIN_MAX_220PCT_STOCK, 'Signals 2hMinMax220pctStock'],
    [StockSignalsEnum.SIGNALS_2H_MIN_MAX_160PCT_STOCK, 'Signals 2hMinMax160pctStock'],
    [StockSignalsEnum.SIGNALS_2H_MIN_MAX_220PCT_STOCK_INSIDE, 'Signals 2hMinMax220pctStockIns'],
    [StockSignalsEnum.SIGNALS_2H_MIN_MAX_160PCT_STOCK_INSIDE, 'Signals 2hMinMax160pctStockIns'],
    [StockSignalsEnum.SIGNALS_2H_MIN_MAX_220PCT_STOCK_3PRED, 'Signals 2hMinMax220pctStock3Pred'],
    [StockSignalsEnum.SIGNALS_SUP_RES_1H_STOCK, 'Signals SupRes1hStock'],
    // [StockSignalsEnum.SIGNALS_TREND_LINES_STOCK_OUTSIDE, 'Signals TrendLineStockOut'],
    [StockSignalsEnum.SIGNALS_OPEN_LINE_STOCK, 'Signals OpenLineStock'],
    [StockSignalsEnum.SIGNALS_PREV_ClOSE_LINE_STOCK, 'Signals PrevCloseLineStock'],

    [StockSignalsEnum.SIGNALS_LAST_2H_AVG_STOCK, 'Signals Last2hAvgStock'],
]);
